import React from 'react';

const capabilities = [
    {
        id: '01',
        icon: 'fa fa-pencil-square-o',
        title: 'Facade Design',
        subtitle: 'ARCHITECTURAL ELEVATION PLANNING',
        description: 'Comprehensive elevation modeling, structural load calculations, and tailored designs crafted for modern building complexes and private villas.'
    },
    {
        id: '02',
        icon: 'fa fa-cogs',
        title: 'Precision Site Execution',
        subtitle: 'SUB-FRAMING & PANEL FITTING',
        description: 'Flawless site execution of ACP composite cladding, frameless toughened glass, spider fittings, and curtain walls with zero-leakage weather sealing.'
    },
    {
        id: '03',
        icon: 'fa fa-users',
        title: 'Skilled & Trained Labours',
        subtitle: 'CERTIFIED INSTALLATION TEAM',
        description: 'Our team of highly skilled and trained labours ensures expert panel alignment, safe high-rise rigging, precise sealant application, and strict quality control on every project.'
    }
];

class WhatWeDo extends React.Component {
    render() {
        return (
            <div className="section-full mobile-page-padding bg-gray p-t80 p-b50 overflow-hide">
                <div className="container">
                    <div className="large-title-block text-center wow fadeInUp" data-wow-duration="1s">
                        <div className="section-head text-center">
                            <div className="sx-separator-outer separator-center">
                                <div className="sx-separator bg-white">
                                    <h3 className="sep-line-one">What We Do</h3>
                                </div>
                            </div>
                            {/* <p style={{ color: '#666', fontSize: '15px', maxWidth: '650px', margin: '15px auto 40px auto', textAlign: 'center' }}>
                                Delivering end-to-end architectural cladding expertise, structural glass facade execution, and skilled trained labours in Coimbatore.
                            </p> */}
                        </div>
                    </div>
                    <div className="section-content">
                        <div className="row justify-content-center">
                            {capabilities.map((item, index) => (
                                <div className="col-lg-4 col-md-6 col-sm-12 m-b30 wow fadeInUp" data-wow-duration="1s" data-wow-delay={`${(index % 3) * 0.15 + 0.1}s`} key={index}>
                                    <div className="bg-white bdr-gray-light bdr-solid bdr-1" style={{
                                        borderRadius: '12px',
                                        overflow: 'hidden',
                                        height: '100%',
                                        boxShadow: '0 6px 20px rgba(0,0,0,0.06)',
                                        borderTop: '4px solid #f03a02',
                                        transition: 'transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-8px)';
                                        e.currentTarget.style.boxShadow = '0 14px 35px rgba(240, 58, 2, 0.14)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.06)';
                                    }}>
                                        <div className="p-a30" style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative' }}>
                                            <div>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '18px' }}>
                                                    <div style={{
                                                        width: '48px',
                                                        height: '48px',
                                                        borderRadius: '10px',
                                                        backgroundColor: 'rgba(240, 58, 2, 0.08)',
                                                        color: '#f03a02',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        fontSize: '22px'
                                                    }}>
                                                        <i className={item.icon || 'fa fa-cube'} />
                                                    </div>
                                                    <span style={{ fontSize: '24px', fontWeight: '800', color: '#e0e0e0' }}>{item.id}</span>
                                                </div>
                                                <span style={{ color: '#f03a02', fontWeight: '700', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '6px' }}>
                                                    {item.subtitle}
                                                </span>
                                                <h4 style={{ fontWeight: '800', fontSize: '19px', marginBottom: '12px', color: '#111111' }}>
                                                    {item.title}
                                                </h4>
                                                <p style={{ color: '#666666', fontSize: '14px', lineHeight: '1.6', marginBottom: '0' }}>
                                                    {item.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default WhatWeDo;
